import './index.css';
import { Button, Flex, IconChrome } from '@smarterservices/smarter-ui';
import { config } from '../../config';
import React, { useEffect } from 'react';
import { checkExtension, isCurrentTabActive } from '../../helpers/helpers';
import StepInstructions from '../Common/StepInstructions';
import DualPane from '../DualPane';

const DownloadExtension = ({ handleStep, stepData }) => {
  useEffect(() => {
    // Start checking to see if the user downloaded the extension yet
    const checkForSpExtension = async () => {
      // First check if this tab is still the active onboarding tab
      if (!isCurrentTabActive()) {
        // Another tab has been opened, redirect to a page informing the user
        // Use replace() to prevent back button from returning to onboarding
        window.location.replace('/session/newer-tab-detected');
        return;
      }
      
      const isExtensionInstalled = await checkExtension();
      if (isExtensionInstalled) {
        handleStep(true);
      } else {
        // The extension was not installed yet, so check again after a timeout
        setTimeout(checkForSpExtension, 500);
      }
    };
    checkForSpExtension();
  }, []);

  return (
    <>
      {stepData && (
        <DualPane
          leftPane={
            <StepInstructions instructions={stepData?.body} />
          }
          rightPane={
            <Flex direction="column" alignItems="center">
              <div className="chrome-colors">
                <IconChrome size="x-large" />
              </div>
              <Button
                color="primary"
                size="medium"
                margin="medium 0"
                onClick={() => {
                  const url = config?.session?.extensionDownloadLink;
                  if (url) {
                    window.open(url, '_blank');
                  }
                }}
              >
                {stepData.button}
              </Button>
            </Flex>
          }
        />
      )}
    </>
  );
};

export default DownloadExtension;
